import React from 'react';
import './Landscapingdesigndetails.css';

const services = [
  {
    title: 'Site Evaluation & Measurements',
    text:
      'Our team starts with on-site measurements and reviews existing conditions. We take into account factors like soil quality, drainage, and the layout of the space to inform the design.',
  },
  {
    title: 'Concept Drawings & Revisions',
    text:
      'We create initial concept drawings that show the overall layout. These drafts are refined based on your feedback to develop a clear, workable plan.',
  },
  {
    title: 'Plant Selection & Layout',
    text:
      'We help choose plants that fit your preferences, climate, and the conditions of your property. Layouts are planned for healthy growth and a balanced appearance.',
  },
];

export default function Landscapingdesigndetails() {
  return (
    <section className="Landscaping-design-details">
      <div className="Landscaping-design-details__container">
        <header className="Landscaping-design-details__header">
          <h2 className="Landscaping-design-details__title">
            Transform Your Property with a Landscape Design
          </h2>
             <div className="rl-title-underline"></div>
          <p className="Landscaping-design-details__subtitle">
            We offer expert design services to help update and improve your outdoor space through
            plant-focused planning and layout.
          </p>
        </header>

        <div className="Landscaping-design-details__grid">
          {services.map(({ title, text }) => (
            <article key={title} className="Landscaping-design-details__card">
              <div className="Landscaping-design-details__card-content">
                <h2 className="Landscaping-design-details__card-title">{title}</h2>
                <p className="Landscaping-design-details__card-text">{text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
